'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { ClientButtonSticky } from '@susu/headless-commerce/components/ButtonSticky/ClientButtonSticky'
import { useCountry } from '@susu/headless-commerce/contexts/country/client'
import { customer } from '@susu/headless-commerce/contexts/customer'
import { useLocale } from '@susu/headless-commerce/contexts/locale/client'
import type {
  PromotionEvents,
  StickyButton,
} from '@susu/headless-commerce/gql/generated/graphql'
import type {
  StickyButtonQuery,
  StickyButtonQueryVariables,
} from '@susu/headless-commerce/gql/generated/stickyButton.operation'
import { usePageType } from '@susu/headless-commerce/hooks/usePageType'
import { trackClickPromotion } from '@susu/headless-commerce/utils/tracking/tracking'
import { useCallback, useRef } from 'react'
import type { OperationResult } from 'urql'

export type ClientStickyButtonContainerSectionProps = {
  query: OperationResult<StickyButtonQuery, StickyButtonQueryVariables>
  automationPageId: string
}

export default function ClientStickyButtonContainerSection({
  query,
  automationPageId,
}: Readonly<ClientStickyButtonContainerSectionProps>) {
  useSignals()
  const pageType = usePageType()
  const locale = useLocale()
  const country = useCountry()

  const button = query.data?.stickyButton as Partial<StickyButton>
  const ref = useRef<HTMLDivElement>(null)

  const handleOnClick = useCallback(() => {
    if (customer.value) {
      trackClickPromotion(
        ref,
        button.link?.promotionEvents as PromotionEvents,
        pageType,
        {
          locale,
          country,
        },
      )
    }
  }, [button.link?.promotionEvents, country, locale, pageType])

  return (
    <ClientButtonSticky
      ref={ref}
      buttonData={button}
      buttonClass={'body-small-regular'}
      onClick={handleOnClick}
      pageType={pageType}
      automationPageId={automationPageId}
    />
  )
}
